import * as Yup from "yup";

import {
  checkTruthyValue,
  futureDateValidation,
  INVALID_RESPONSE_MSG,
  percentValueValidation,
} from "utils/validation";

export const baseEmploymentValidation = Yup.object().shape({
  awareOfAnyChangesToIncome: Yup.bool()
    .typeError(INVALID_RESPONSE_MSG)
    .required(INVALID_RESPONSE_MSG),

  incomeChangesDetails: Yup.string().when("awareOfAnyChangesToIncome", {
    is: (value: any) => checkTruthyValue(value),
    then: () => Yup.string().required(INVALID_RESPONSE_MSG),
    otherwise: () => Yup.string().nullable(),
  }),

  hasOtherSourcesOfIncome: Yup.bool()
    .typeError(INVALID_RESPONSE_MSG)
    .required(INVALID_RESPONSE_MSG),

  anticipatedRetirementAge: Yup.number()
    .typeError(INVALID_RESPONSE_MSG)
    .required(INVALID_RESPONSE_MSG),

  numberOfJobs: Yup.number()
    .required(INVALID_RESPONSE_MSG)
    .typeError(INVALID_RESPONSE_MSG),

  employmentDetail: Yup.array().of(
    Yup.object({
      employmentStatus: Yup.string().required(INVALID_RESPONSE_MSG),
      percentBusinessOwned: percentValueValidation,
      shareholdingPercentInCompany: percentValueValidation,
      endDate: futureDateValidation,
    }),
  ),
});
